/**
 * Chinese translations for watchout analysis
 */
const watchout = {
  watchout: {
    title: "需要注意的方面",
    noData: "暂无可用的注意事项分析数据",
    命宫: {
      紫微: "别太骄傲、太高冷、要求太高而失去人缘",
      天府: "过于保守，缺乏创新",
      天相: "过于追求和谐，忽视自身需求",
      武曲: "情感表达较弱，容易压抑、做牛做马却闷着头",
      天机: "想太多、犹豫不决、计划永远赶不上行动",
      文曲: "太情绪化、想太多、容易自怜自溺",
      文昌: "过度理性、太严谨、在意形式导致行动力下降",
      贪狼: "容易三分钟热度、能量分散、情感欲望拉扯多",
      太阳: "付出太多容易被消耗、不懂表达脆弱、爱面子撑场",
      太阴: "容易压抑情绪、太为别人着想、不敢冲突",
      巨门: "易被误解为攻击性、常因表达伤人",
      天同: "逃避冲突、容易退缩、过度依赖他人评价",
      七杀: "冲太快没人跟／情绪起伏大／爆发完后容易耗竭",
      破军: "常自毁式换跑道／否定过去过头／难稳定下来",
      左辅: "容易过度牺牲自我，缺乏主见",
      右弼: "太在意他人眼光，容易委屈自己",
      天梁: "过度包揽、容易替人背责",
      廉贞: "容易刚愎自用、情绪不稳"
    },
    财帛: {
      紫微: "太依赖权贵，或过度投资门面、排场",
      天府: "过于保守，错失机会",
      天相: "太怕要价、太讲人情、被人情消费",
      武曲: "低估自己价值／用体力换钱／沉迷细节而忽略大局",
      天机: "想太多导致错失入场机会，方案变来变去影响财务稳定",
      文曲: "情绪影响收支节奏／接案型容易高低起伏大",
      文昌: "太过理性压抑消费、过度花时间优化系统反而错失入金节奏",
      贪狼: "太想花、赚钱也快花得快、赚多但无节制留不住",
      太阳: "过度付出、定价偏低、怕别人负担不敢报价",
      太阴: "容易被情感带走、怕要价、常常帮太多不该帮的人",
      巨门: "说得多做得少、表达越界失客户",
      天同: "怕报价／给太多免费价值／靠感情撑服务",
      七杀: "贪快／管不住手／情绪交易",
      破军: "反复换方向、没收口系统、看太大做太慢",
      左辅: "过度付出，回报不对等",
      右弼: "人情债过多，导致资源流失",
      天梁: "过于理想化，缺乏金钱意识",
      廉贞: "短视近利、好高骛远"
    },
    官禄: {
      紫微: "过于追求权力，忽视团队协作",
      天府: "过于保守，缺乏创新",
      天相: "怕冲突导致让步过多／不善拒绝而被压榨",
      武曲: "压过主管、推不开团队、太用力失去弹性",
      天机: "不爱管人／缺乏表达，容易被忽视",
      文曲: "情绪管理影响项目交付／完美主义／难以与团队系统节奏配合",
      文昌: "太在意小细节／拖延症发作／完成度永远不满意",
      贪狼: "太看心情工作／难维持长线专注／常因关系搞砸合作",
      太阳: "怕求助／好强不肯放手／坚持旧方式不更新",
      太阴: "缺乏曝光、不敢推自己、容易被看轻",
      巨门: "表达太快团队跟不上／做事风格难被理解",
      天同: "太不主动就被边缘化／怕冲突就不争取机会",
      七杀: "难融入团队文化／太强调自由／带不住人",
      破军: "没稳定系统／易被误解为不靠谱／团队难配合你节奏",
      左辅: "缺乏个人声音，容易被忽视",
      右弼: "容易被情绪左右，影响判断",
      天梁: "过于宽容，放任问题扩大",
      廉贞: "太过强势，易树敌"
    }
  }
};

export default watchout; 